<template>
  <div class="footer" v-if="configData">
    <div class="tagImgBox">
      <img
        class="footer-tags"
        src="../../assets/images/common/footer_info.png"
        alt="tags"
      />
    </div>
    <div class="footerEnd" v-if="showFoot_text">
      <ul class="linkUl b">
        <li v-if="configData.about">
          <a :href="configData.about" target="_blank"> 关于我们 </a>
        </li>
        <li class="b" v-if="configData.buiness_email">
          <span v-if="configData.buiness_email.name"
            >{{ configData.buiness_email.name }}：</span
          >
          <div v-if="configData.buiness_email">
            <span
              v-for="(data, index) in configData.buiness_email.item"
              :key="index"
            >
              {{ data }}
            </span>
          </div>
        </li>
        <li v-if="configData.mobile">
          <p
            class="p2"
            v-for="(item, index) in configData.mobile.phone"
            :key="index"
          >
            公司电话：{{ item }}
          </p>
        </li>
      </ul>
      <div
        class="copy b pc"
        v-if="configData.footer_description"
        v-html="configData.footer_description"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'appFooter',
  data() {
    return {
      friendLinks: [
        {
          text: '关于我们',
          scheme: 'http://www.pandayoufu.com?from=pc-footer'
        },
        {
          text: '联系我们',
          scheme: 'http://www.pandayoufu.com?from=pc-footer'
        }
      ],
      showFoot_text: true
    };
  },
  mounted() {
    this.configHide();
  },
  methods: {
    configHide() {
      if (!this.config || !this.config.pc_hide_model) {
        return false;
      }
      this.config.pc_hide_model.some(item => {
        if (item == 'foot_text') {
          this.showFoot_text = false;
        }
      });
    }
  },
  computed: {
    ...mapState('common', ['config']),
    configData() {
      return this.$store.state.common.config;
    }
  },
  watch: {
    config() {
      this.configHide();
    }
  }
};
</script>

<style lang="scss" scoped>
ul,
li {
  list-style: none;
}
.footer {
  width: 100%;
  height: 100%;
  .tagImgBox {
    padding: 30px 0;
    border-bottom: 1px solid #dddddd;
    img {
      width: 100%;
    }
  }
  .footerEnd {
    padding: 30px 0 40px 0;
    .linkUl {
      justify-content: center;
      li {
        margin-right: 20px;
        font-size: 14px;
        line-height: 14px;
        a {
          color: #555555;
          &:hover {
            color: #ea0000;
          }
        }
        &:nth-child(1) {
          padding-right: 20px;
        }
        &:nth-last-child(1) {
          margin-right: 0;
        }
        &:nth-child(1) {
          border-right: 1px solid #868686;
        }
      }
    }
    .copy {
      text-align: center;
      margin-top: 10px;
      .address {
        margin-left: 10px;
      }
      /deep/ a {
        color: #333;
        &:hover {
          @include color_primary($color-primary);
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
